






import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {AUTH_GET_CLIENT, AUTH_GET_COUNTRY} from '@/store/modules/authentication/types';
import {Client} from '@/store/modules/authentication/interfaces';
import {TupleDictionary} from '@/utils/tupleDictionary';
import {ClientEnum} from '@/enums/client.enum';
import {CountryEnum, CountryType} from '@/enums/country.enum';
import ReportPowerBiContainer from '@/modules/neodash/components/report-powerbi-container/report-powerbi-container.vue';
import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';

@Component({
  name: 'PbiConversionReportPage',
  components: { ReportPowerBiContainer }
})
export default class PbiConversionReportPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();
  public dictReports = new TupleDictionary<[ClientEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    this.dictReports.set([ClientEnum.GM, CountryEnum.Brasil], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'd22cda94-144d-40da-b2dc-7b00737a054c' });
    this.dictReports.set([ClientEnum.Volkswagen, CountryEnum.Brasil], { brand: 'VW', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '8c3d8d43-6e80-4b5b-af6d-578b3dd5205a' });

    this.crrReport = this.dictReports.get([this.client.id, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Conversion Report`);
  }
}
